import React, { useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import "../assets/css/agent/chat-box.scss";
import { Link } from "react-router-dom";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import useChat from '../config/useChat';
import jwt from 'jwt-decode';
import axiosInstance from "../environment/axiosInstance";
import { AiOutlineMinus } from "react-icons/ai";
import { IoChatbubbles } from "react-icons/io5";
import { MdSend } from "react-icons/md";

function Chat(props) {
    const { ticketId } = useParams();
    const [message, setMessage] = useState("");
    const messageRef = useRef("");
    const { messages, sendMessage } = useChat(ticketId);
    const [ticket, setTicket] = useState(null);
    const [customer, setCustomer] = useState(null);
    const bottomRef1 = useRef(null);

    useEffect(() => {
        axiosInstance
            .get(process.env.REACT_APP_API_URL + "/support/business_owner/ticket/" + ticketId, {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem("user_token")}`
                }
            })
            .then(response => {
                if (response.data.statusCode == 200) {
                    setTicket(response.data.Data.ticket);
                    setCustomer(response.data.Data.customer);
                }
            });
    }, []);

    useEffect(() => {
        // 👇️ scroll to bottom every time messages change
        bottomRef1.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages]);

    const sendMessageClick = () => {
        if (message) {
            if (messageRef.current.value === "") {
                return false;
            }

            const messageObject = {
                message: message,
                status: "unseen",
                to: customer?._id,
                chat_id: ticket?.chat
            };

            axiosInstance
                .post(process.env.REACT_APP_API_URL + "/support/business_owner/message/send",
                    messageObject, {
                    headers: {
                        "Authorization": `Bearer ${localStorage.getItem("user_token")}`
                    }
                })
                .then(response => {
                    if (response.data.statusCode == 200) {
                        sendMessage(messageObject);
                        setMessage("");
                    }
                });
        }
    }

    return (
        <div className="chat">
            <div className="chat-box">
                <div className="header">
                    <p className="m-0">Live Chat</p>
                    <AiOutlineMinus
                        size={22}
                        onClick={props.minimizeChat}
                        style={{
                            cursor: "pointer"
                        }}
                    />
                </div>
                <div className="body">
                    {
                        messages.map(message => {
                            if (message.to == jwt(localStorage.getItem("user_token"))?.id) {
                                return (
                                    <div className="received-msg">
                                        <div className="d-flex">
                                            <div className="message-box">
                                                <p className="m-0 message-text">{message.message}</p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            else {
                                return (
                                    <div className="ms-auto sent-msg">
                                        <div className="d-flex justify-content-end">
                                            <div className="message-box">
                                                <p className="m-0 message-text">{message.message}</p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        })
                    }
                    <div ref={bottomRef1} />
                </div>
                <div className="bottom">
                    <input
                        type="text"
                        className="w-100 msg-input"
                        placeholder="Type message here..."
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                    />
                    <button
                        className="btn p-0 h-100"
                        onClick={sendMessageClick}
                    >
                        <MdSend
                            size={20}
                            color="#7455F6"
                        />
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Chat;